import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import cx from 'classnames';
import Avatar from '@components/@core/Avatar';

const AvatarButton = ({ className, avatar, username, companyName, size, slug, onClick }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (slug && slug !== '') {
            const route = `/${slug}/about`;
            navigate(route);
        }
    };

    return (
        <div className={cx('ds-avatar-button', size, className)} onClick={handleClick}>
            <Avatar className="mr-2" type="logo" url={avatar} borderWidth={1} isSponsored={true} />
            <div>
                <p className="ds-avatar-button-username">{username}</p>
                {/* {companyName && <p className="ds-avatar-button-company">{companyName}</p>} */}
            </div>
        </div>
    );
};

AvatarButton.propTypes = {
    className: PropTypes.string,
    avatar: PropTypes.string,
    username: PropTypes.string,
    companyName: PropTypes.string,
    size: PropTypes.oneOf(['small', 'regular', 'large']),
    slug: PropTypes.string,
    onClick: PropTypes.func,
};

AvatarButton.defaultProps = {
    className: '',
    avatar: null,
    username: '',
    companyName: 'Unknown',
    size: 'regular',
    slug: null,
};

export default AvatarButton;
